exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-detail-collapse-bunches .card {\n  background-color: #E3E6E8 !important;\n}\n.list-detail-collapse-bunches .card .b-checkbox {\n  background-color: #E3E6E8 !important;\n}", ""]);

// exports
